import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Booking, Booking_Breakup } from 'src/models/booking.model';
import { Reservations } from 'src/models/reserve.model';
import { BookingService } from 'src/services/booking.service';
import { CrudService } from 'src/services/crud.service';
import { DataService } from 'src/services/data.service';
import { ReserveService } from 'src/services/reserve.service';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.css']
})
export class ReservationComponent implements OnInit {
  booking = new Booking();
  bookingBreakup = new Booking_Breakup();
  reservations = new Reservations();
  standardTent: any;
  familyTent: any;
  bookingCat: any;

  

  tentName: any;
  constructor(private dataService: DataService, private reserveService: ReserveService,
    private bookingService: BookingService, private route: ActivatedRoute, private router: Router, private _crudService: CrudService) {
  }

  ngOnInit() {

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
   
    // var type = this.route.snapshot.queryParamMap.get('type');
    // if (atob(type) == 'st') {
    //   this.tentName = 'Standard Tent Booking';
    // }
    // else if (atob(type) == 'ft') {
    //   this.tentName = 'Family Tent Booking';
    // }
  }



  checkInResponse: any = "";
  CheckInDateChange() {
    this.checkInResponse = "";
    this.reservations.RESERVATION_CHECK_OUT_DATE = null;
    var date1 = new Date();
    var date2 = new Date(this.reservations.RESERVATION_CHECK_IN_DATE);

    // To calculate the time difference of two dates 
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates 
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days <= 0) {
      this.checkInResponse = "Check-In date must be greater than Current Date"
      //alert("Check-In date must be greater than Current Date");
      this.reservations.RESERVATION_CHECK_IN_DATE = null;
    }
  }

  CheckOutDateChange() {
    this.checkInResponse = "";
    var d11 = this.reservations.RESERVATION_CHECK_IN_DATE;// = new Date((document.getElementById("datepicker") as HTMLInputElement).value);
    var d22 = this.reservations.RESERVATION_CHECK_OUT_DATE;//

    var date1 = new Date(this.reservations.RESERVATION_CHECK_IN_DATE);
    var date2 = new Date(this.reservations.RESERVATION_CHECK_OUT_DATE);

    // To calculate the time difference of two dates 
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates 
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    //To display the final no. of days (result) 
    console.log("Total number of days between dates  <br>"
      + date1 + "<br> and <br>"
      + date2 + " is: <br> "
      + Difference_In_Days);

    if (Difference_In_Days <= 0) {
      this.checkInResponse = "Checkout date must be greater than Check-In Date";
      this.reservations.RESERVATION_CHECK_OUT_DATE = null;
      this.reservations.RESERVATION_NO_OF_DAYS = 0;
    }
    else {
      this.reservations.RESERVATION_NO_OF_DAYS = Difference_In_Days;
    }
  }

  //#region Form Validation
  NameResponse: any;
  EmailResponse: any;
  PhoneResponse: any;
  AmountResponse: any;
  PaymentResponse: any;

  validations() {

    if (this.ValidateName() && this.ValidateEmail() && this.ValidatePhone() && this.ValidateAmount()) {      
      return true;
    }
    else
       return false;

    // if (this.reservations.RESERVATION_EMAIL == null || this.reservations.RESERVATION_EMAIL == '' || this.reservations.RESERVATION_EMAIL == undefined) {
    //   this.EmailResponse = 'Email is Required';
    //   return true;
    // }
    // if (this.reservations.RESERVATION_MOBILE_NO == null || this.reservations.RESERVATION_MOBILE_NO == '' || this.reservations.RESERVATION_MOBILE_NO == undefined) {
    //   this.PhoneResponse = 'Phone No. is Required';
    //   return true;
    // }
    // if (this.booking.Payment_Mode == '' || this.booking.Payment_Mode == undefined) {
    //   this.PaymentResponse = 'Payment Option is Required';
    //   return true;
    // }
    // if (!this.ValidateEmail()) {
    //   return true;
    // }

    // if (!this.validatePhone(this.reservations.RESERVATION_MOBILE_NO)) {
    //   return true;
    // }

  }
  //#endregion

  //#region Email
  ValidateEmail() {

    if (!this.dataService.IsValidString(this.reservations.RESERVATION_EMAIL)) {
      this.EmailResponse = 'Email is Required';
    }
    else {
      var regularExpression = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      var valid = regularExpression.test(this.reservations.RESERVATION_EMAIL) //match a letter _and_ a number
      if (!valid) {
        this.EmailResponse = "Please enter valid Email ID";
      }
      else this.EmailResponse = null;
    }

    return !this.dataService.IsValidString(this.EmailResponse);

  }
  //#endregion

  //#region Phone no. validation
  ValidatePhone() {
    if (!this.dataService.IsValidString(this.reservations.RESERVATION_MOBILE_NO)) {
      this.PhoneResponse = 'Phone No. is Required';
    }
    else
    {
      if(!/^[0-9]+$/.test(this.reservations.RESERVATION_MOBILE_NO)){
        this.PhoneResponse = "Please only enter numeric characters.";
      }
      else if (this.reservations.RESERVATION_MOBILE_NO.length < 10) {
        this.PhoneResponse = "Please enter 10 digit valid Phone Number";
      }
      else
      this.PhoneResponse =null;
    }    

    return !this.dataService.IsValidString(this.PhoneResponse);
  }
  //#endregion


  ValidateName()
  {
    if (!this.dataService.IsValidString(this.reservations.RESERVATION_NAME)) {
      this.NameResponse = 'Name is Required';
    }
    else
      this.NameResponse =null;

      return !this.dataService.IsValidString(this.NameResponse);
  }
  
  ValidateAmount() {
    if (!this.dataService.IsValidString(this.reservations.RESERVATION_ADVANCE_AMT)) {
      this.AmountResponse = 'Amount is Required';
    }
    else
    {
      if(!/^[0-9]+$/.test(this.reservations.RESERVATION_ADVANCE_AMT)){
        this.AmountResponse = "Please only enter numeric value.";
      }
      // else if ( parseInt(this.reservations.RESERVATION_ADVANCE_AMT) < 1000) {
      //   this.AmountResponse = "Please enter amount grater than 1000.";
      // }
      else
        this.AmountResponse =null;
    } 

    return !this.dataService.IsValidString(this.AmountResponse);

  }


  reserveResponse: any = '';
  saveReservation() {
    debugger;
    if(!this.validations()){
      return;
    }
   
    this.dataService.setOption('title', this.reservations.RESERVATION_TITLE);
    this.dataService.setOption('name', this.reservations.RESERVATION_NAME);
    this.dataService.setOption('email', this.reservations.RESERVATION_EMAIL);
    this.dataService.setOption('mobile', this.reservations.RESERVATION_MOBILE_NO);
    this.dataService.setOption('adult', this.reservations.RESERVATION_NO_OF_MEMBER);
    this.dataService.setOption('child', this.reservations.RESERVATION_NO_OF_CHILD);
    this.dataService.setOption('amount', this.reservations.RESERVATION_ADVANCE_AMT);
    this.dataService.setOption('checkIn', this.reservations.RESERVATION_CHECK_IN_DATE);
    this.dataService.setOption('checkOut', this.reservations.RESERVATION_CHECK_OUT_DATE);
    this.dataService.setOption('request', this.reservations.RESERVATION_SPECIAL_REQUEST);
    this.dataService.setOption('days', this.reservations.RESERVATION_NO_OF_DAYS);

    this.router.navigateByUrl(`/proceed-payment`);

    // this.reserveService.reserve(this.reservations).subscribe((data: any) => {
    //   alert(data);
    //   //this.reserveResponse = data;
    //   this.router.navigateByUrl(`/proceed-payment?n=${RESERVATION_NAME}&e=${RESERVATION_EMAIL}&d=${RESERVATION_NO_OF_DAYS}&m=${RESERVATION_NO_OF_MEMBER}&c=${RESERVATION_NO_OF_CHILD}&amt=${RESERVATION_ADVANCE_AMT}&mn=${RESERVATION_MOBILE_NO}&cin=${this.reservations.RESERVATION_CHECK_IN_DATE}&con=${this.reservations.RESERVATION_CHECK_IN_DATE}`);


    // }, (error: any) => {
    //   console.log(error);
    // }
    // )

  }

}
